import {
  OccupationalAccidentAccidentMedicalMinimum,
  OccupationalAccidentAdAndDMinimum,
  WorkInjuryAcceptedCoverageType,
  WorkInjuryEmployerLiabilityBundle
} from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import {
  WSCard,
  WSControlGroup,
  WSElement,
  WSForm,
  WSIconList,
  WSInfoBox,
  WSList,
  WSSectionToolbar,
  WSSelect
} from "@wingspanhq/fe-component-library";
import { WSCardProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSCard/WSCard";

import { getLimitOptions } from "./getLimitOptions";

export const WORKER_OCCUPATIONAL_ACCIDENT_MINIMUM_COMMON: OccupationalAccidentAccidentMedicalMinimum = 250000;
const WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS: OccupationalAccidentAccidentMedicalMinimum[] =
  [100000, 250000, 500000, 1000000];

export const WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUM_COMMON: OccupationalAccidentAdAndDMinimum = 50000;
const WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS: OccupationalAccidentAdAndDMinimum[] =
  [50000, 100000, 250000, 500000];

const WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS_OPTIONS = getLimitOptions(
  WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS,
  WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUM_COMMON
);

const WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS_OPTIONS = getLimitOptions(
  WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS,
  WORKER_OCCUPATIONAL_ACCIDENT_MINIMUM_COMMON
);

export const FormPartialWorkInjury: React.FC<WSCardProps> = props => {
  return (
    <WSCard {...props}>
      <WSSectionToolbar title="Your requirements for uploaded insurance" />
      <WSList gap="L" mt="L">
        <WSForm.Field
          component={WSControlGroup}
          componentProps={{
            chip: true,
            helperText: "Select one",
            options: [
              {
                label: (
                  <>
                    <b>Workers' Compensation only</b> - Traditional
                    state-regulated coverage
                  </>
                ),
                value: WorkInjuryAcceptedCoverageType.WorkersCompensation
              },
              {
                label: (
                  <>
                    <b>Occupational Accident only</b> - Alternative injury
                    coverage for 1099s
                  </>
                ),
                value: WorkInjuryAcceptedCoverageType.OccupationalAccident
              },
              {
                label: (
                  <>
                    <b>Either one</b> - Accept Workers' Comp OR Occupational
                    Accident
                  </>
                ),
                value: WorkInjuryAcceptedCoverageType.Either
              }
            ],
            required: true,
            size: "S",
            type: "radio"
          }}
          label="What coverage types will you accept?"
          name="coverageType"
        />

        <WSForm.Value name="coverageType">
          {(coverageType: WorkInjuryAcceptedCoverageType) => (
            <>
              <WSInfoBox
                icon="settings"
                style={{
                  display: [
                    WorkInjuryAcceptedCoverageType.WorkersCompensation,
                    WorkInjuryAcceptedCoverageType.Either
                  ].includes(coverageType)
                    ? "block"
                    : "none"
                }}
                theme="info"
                title="Worker’s Compensation coverage"
              >
                <WSElement fullWidth>
                  <WSForm.Field
                    component={WSSelect}
                    componentProps={{
                      helperText:
                        "Per accident / Total for disease / Per employee disease limits for each coverage tier (select one)",
                      options: [
                        {
                          label:
                            "$100,000 / $500, 000 / $100, 000 Standard coverage",
                          value:
                            WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred
                        },
                        {
                          label: "$500,000 / $500,000 / $500,000",
                          value:
                            WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred
                        },
                        {
                          label: "$1,000,000 / $1,000,000 / $1,000,000",
                          value:
                            WorkInjuryEmployerLiabilityBundle.OneMillionBundle
                        }
                      ],
                      required: true
                    }}
                    label="Employer's liability limits (minimum)"
                    name="workersCompLimitMinimum"
                  />
                </WSElement>
              </WSInfoBox>

              <WSInfoBox
                icon="settings"
                style={{
                  display: [
                    WorkInjuryAcceptedCoverageType.OccupationalAccident,
                    WorkInjuryAcceptedCoverageType.Either
                  ].includes(coverageType)
                    ? "block"
                    : "none"
                }}
                theme="info"
                title="Occupational Accident coverage"
              >
                {/* TODO: update lib*/}
                <WSElement style={{ width: "100%" }}>
                  <WSForm.Field
                    component={WSSelect}
                    componentProps={{
                      helperText:
                        "Maximum medical benefits for each work injury (select one)",
                      options: WORKER_OCCUPATIONAL_ACCIDENT_MINIMUMS_OPTIONS,
                      required: true
                    }}
                    label="Medical coverage (minimum per accident)"
                    name="occAccidentMedicalMinimum"
                  />

                  <WSForm.Field
                    component={WSSelect}
                    componentProps={{
                      helperText:
                        "Lump sum for death or permanent injury from work accident (select one)",
                      options:
                        WORKER_OCCUPATIONAL_ACCIDENT_AD_AND_D_MINIMUMS_OPTIONS,
                      required: true
                    }}
                    label="Death & dismemberment benefit (minimum)"
                    mt="M"
                    name="occAccidentDeathMinimum"
                  />
                </WSElement>
              </WSInfoBox>
            </>
          )}
        </WSForm.Value>

        <WSInfoBox
          icon="shield-check-fill"
          theme="neutral"
          title="We automatically verify:"
        >
          <WSIconList
            iconProps={{
              color: "green500",
              name: "check-circle",
              size: "S"
            }}
            items={[
              "Valid COI format",
              "Contractor name matches",
              "Your company listed as certificate holder",
              "Coverage currently active",
              "Correct coverage type (WC or OccAcc)",
              "All limits meet your minimums"
            ]}
          />
        </WSInfoBox>
      </WSList>
    </WSCard>
  );
};
